import { getCustomerSalesReport } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { CustomerSalesResponse } from "@/types/report-type";

export function useCustomerSales(
    fromDate: string,
    toDate: string,
    limit?: number
) {
    const cacheKey = buildCacheKey("customer-sales", { fromDate, toDate, limit });

    return useCollectionData<CustomerSalesResponse>(
        cacheKey,
        () => getCustomerSalesReport(fromDate, toDate, limit),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
